import * as React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import moment from 'moment';
import { Link } from 'react-router';
import AssetsGallery from '../../generic/AssetsGallery/_lazy';
import { FacebookProvider } from 'react-facebook';
import { Comments } from 'react-facebook';
import RelatedBlogPosts from './RelatedBlogPosts';
import FacebookLikeButton from '../../generic/FacebookLikeButton';
import CleanedBodyHTML from '../../CleanedBodyHTML';
import SocialNetworks from '../../generic/SocialNetworks';
import parsePathname from '../../utils/parsePathname';
import CountdownTimer from '../../generic/CountdownTimer';
import Rodal from 'rodal';
import LeadMagnetFunnelForm from '../../Tutorials/TutorialDetail/LeadMagnetFunnelForm';
import FavoriteButton from '../../generic/FavoriteButton';
export default function () {
    function repeatFbImage1(props, metaTitle, metaDescription, fbImage, fbImageIndex) {
        return React.createElement('meta', {
            'property': 'og:image',
            'content': fbImage.original,
            'key': fbImageIndex
        });
    }
    function scopeMetaTitleMetaDescription2(props) {
        var metaTitle = props.metaTitle || props.title;
        var metaDescription = props.metaDescription || props.description;
        return React.createElement.apply(this, [
            Helmet,
            {},
            React.createElement('title', {}, metaTitle, ' | Stan Winston School of Character Arts'),
            React.createElement('meta', {
                'name': 'description',
                'content': metaDescription
            }),
            React.createElement('meta', {
                'property': 'og:title',
                'content': metaTitle
            }),
            React.createElement('meta', {
                'property': 'og:description',
                'content': metaDescription
            }),
            React.createElement('meta', {
                'property': 'og:type',
                'content': 'article'
            }),
            !props.facebookShareImages.length ? React.createElement('meta', {
                'property': 'og:image',
                'content': props.photo.original,
                'key': '1600'
            }) : null,
            props.facebookShareImages.length ? _.map(props.facebookShareImages, repeatFbImage1.bind(this, props, metaTitle, metaDescription)) : null
        ]);
    }
    function onKeyUp3(props, banner, bannerIndex, withTimer, event) {
        keyUpHandler(event, this.onClickCTA);
    }
    function scopeWithTimer4(props, banner, bannerIndex) {
        var withTimer = !_.isNull(banner.countdownDate);
        return React.createElement('div', {
            'className': 'banner-slide' + ' ' + _.transform({ linkable: !_.isNull(banner.link) }, function (res, value, key) {
                if (value) {
                    res.push(key);
                }
            }, []).join(' '),
            'style': { backgroundImage: 'url(' + banner.asset.original + ')' },
            'onClick': this.onClickCTA,
            'onKeyUp': onKeyUp3.bind(this, props, banner, bannerIndex, withTimer),
            'tabIndex': '0'
        }, React.createElement('a', {
            'aria-label': 'banner.title',
            'className': 'overlay' + ' ' + _.transform({ 'gradient': banner.hasGradient }, function (res, value, key) {
                if (value) {
                    res.push(key);
                }
            }, []).join(' '),
            'href': banner.link
        }), React.createElement('div', { 'className': 'wrapper' }, React.createElement('div', { 'className': 'banner-info' }, React.createElement('div', { 'className': 'title' }, '\n                  ', banner.title, '\n              '), React.createElement('div', { 'className': 'description' }, React.createElement('p', {}, '\n                      ', banner.description, '\n                  '))), withTimer ? React.createElement('div', {
            'className': 'countdown',
            'key': '2875'
        }, React.createElement(CountdownTimer, {
            'targetDate': banner.countdownDate,
            'startDelay': 2000,
            'interval': 1000,
            'leadingZero': true
        })) : null, !_.isNull(banner.ctaLabel) && !_.isNull(banner.ctaUrl) ? React.createElement('div', {
            'className': 'cta',
            'key': '3141'
        }, React.createElement('a', { 'href': banner.ctaUrl }, React.createElement('button', { 'className': 'btn -orange' }, banner.ctaLabel))) : null));
    }
    function repeatBanner5(props, banner, bannerIndex) {
        return React.createElement('div', { 'className': 'banner' }, scopeWithTimer4.apply(this, [
            props,
            banner,
            bannerIndex
        ]));
    }
    function repeatTag6(props, tag, tagIndex) {
        return React.createElement('li', {
            'className': 'tag',
            'key': tagIndex
        }, React.createElement(Link, { 'to': '/search?q=' + encodeURIComponent(tag) }, tag));
    }
    function scopeProps7() {
        var props = this.props;
        return React.createElement('div', { 'id': 'Post' }, scopeMetaTitleMetaDescription2.apply(this, [props]), React.createElement.apply(this, [
            'div',
            { 'className': 'post-header wrapper' },
            _.map(this.props.adBanners, repeatBanner5.bind(this, props)),
            props.category ? React.createElement('div', {
                'className': 'category',
                'key': '3387'
            }, props.category.name) : null,
            React.createElement('div', { 'className': 'title' }, React.createElement('h1', {}, props.title), React.createElement('h2', { 'className': 'tagline' }, props.description)),
            props.orderDate ? React.createElement('div', {
                'className': 'date-created',
                'key': '3583'
            }, '\n      ', moment(props.orderDate).format(DISPLAY_DATE_FORMAT), '\n    ') : null,
            React.createElement('div', { 'className': 'forum' }, React.createElement('a', {
                'href': 'https://forums.stanwinstonschool.com',
                'target': '_blank'
            }, React.createElement('i', { 'className': 'icon icon-forum' }), React.createElement('span', {}, 'Discuss on our Forums'))),
            React.createElement(FavoriteButton, {
                'favorited': props.favorited,
                'url': props.url
            }),
            this.props.status === 'published' ? React.createElement(SocialNetworks, {
                'url': props.socialUrl,
                'key': '3975'
            }) : null
        ]), React.createElement('div', { 'className': 'blog-content' }, React.createElement('div', { 'className': 'wrapper' }, React.createElement('img', {
            'src': props.photo.large,
            'className': 'main-image',
            'alt': props.title,
            'role': 'presentation'
        }), props.body ? React.createElement('div', {
            'className': 'body',
            'key': '4229'
        }, React.createElement(CleanedBodyHTML, { 'HTMLToClean': props.body }), React.createElement(CleanedBodyHTML, { 'HTMLToClean': props.nonIndexedBody })) : null, props.tags ? React.createElement.apply(this, [
            'ul',
            {
                'className': 'tags',
                'key': '4406'
            },
            _.map(props.tags, repeatTag6.bind(this, props))
        ]) : null, props.assets && props.assets.length ? React.createElement(AssetsGallery, {
            'assets': props.assets,
            'key': '4617'
        }) : null, React.createElement(FacebookProvider, { 'appId': FACEBOOK_APP_ID }, React.createElement(Comments, {
            'width': '100%',
            'href': FB_COMMENTS_BASE + parsePathname(props.location.pathname)
        })))), React.createElement('div', { 'className': 'related-posts wrapper' }, React.createElement('div', { 'className': 'forum' }, React.createElement('a', {
            'href': 'https://forums.stanwinstonschool.com',
            'target': '_blank'
        }, React.createElement('i', { 'className': 'icon icon-forum' }), React.createElement('span', {}, 'Discuss on our Forums'))), props.user ? React.createElement(RelatedBlogPosts, {
            'user': props.user,
            'currentBlogPostId': props.id,
            'key': '5139'
        }) : null), React.createElement('div', { 'id': 'LeadMagnetFunnelModal' }, React.createElement(Rodal, {
            'visible': this.props.displayLeadMagnetFunnelModal && !this.props.wasLeadMagnetFunnelModalDismissed && !this.props.wasLeadMagnetFunnelModalSubmitted && !this.props.isAuth,
            'onClose': this.onCloseLeadMagnetDialog,
            'width': this.props.isMobile ? 375 : 800
        }, React.createElement(LeadMagnetFunnelForm, {
            'isPopUp': true,
            'tag': 'Blog Email Lead'
        }))));
    }
    return scopeProps7.apply(this, []);
}